import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ScriptLoaderService {
    public async loadScript(url: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            let scriptElement = document.createElement("script");
            scriptElement.type = "text/javascript";
            scriptElement.src = url;

            let scriptError: boolean = false;
            let scriptErrorHandler = () => {
                scriptError = true
            };

            scriptElement.onload = () => {
                if (scriptError) reject();
                else resolve();
                window.removeEventListener("error", scriptErrorHandler);
            };

            scriptElement.onerror = (error: any) => {
                reject(error);
                window.removeEventListener("error", scriptErrorHandler);
            };

            window.addEventListener("error", scriptErrorHandler);
            document.getElementsByTagName('body')[0].appendChild(scriptElement);
        });
    }
}